import * as React from 'react';
import {useEffect} from "react";
import {isCentinelMessageOriginAllowed} from "../../helpers";

export default function DdcForm({formRef, jwtInputRef, setIsDdcComplete}) {
    useEffect(() => {
        const handleMessage = function (event) {
            if (!isCentinelMessageOriginAllowed(event.origin) || !event.data) {
                return;
            }

            const data = JSON.parse(event.data);
            if (data.MessageType === 'profile.completed' && data.Status === true) {
                setIsDdcComplete(true);
            }
        }
        window.addEventListener("message", (event) => handleMessage(event));

        return () => {window.removeEventListener("message", handleMessage)};
    }, []);

    return (
        <form target="3ds_device_data_collection_iframe" ref={formRef} method="POST" action="">
            <input ref={jwtInputRef} type="hidden" name="JWT" value=""/>
        </form>
    );
}
